module.exports = __webpack_public_path__ + "assets/img/W3-4-F.4a3b5446.png";